import { render, staticRenderFns } from "./myVouchersPage.vue?vue&type=template&id=399845ce&scoped=true"
import script from "./myVouchersPage.vue?vue&type=script&lang=ts"
export * from "./myVouchersPage.vue?vue&type=script&lang=ts"
import style0 from "./myVouchersPage.vue?vue&type=style&index=0&id=399845ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399845ce",
  null
  
)

export default component.exports